import {DoOpeningHour} from '../../interfaces/doctors/do-opening-hour';
import {DoOpeningHourPeriod} from '../../enums/doctors/do-opening-hour-period';

export class DoOpeningHourFactory {
  /**
   *
   * @param doOpeningHour
   */
  public static fromObject(doOpeningHour: any): DoOpeningHour {
    return new class implements DoOpeningHour {
      withAppointmentOnly: boolean = doOpeningHour.with_appointment_only;
      comment: string = doOpeningHour.comment;
      doDoctorId: number = doOpeningHour.do_doctor_id;
      id: number = doOpeningHour.id;
      timeFrom: string = doOpeningHour.time_from;
      timeTo: string = doOpeningHour.time_to;
      weekday: number = doOpeningHour.weekday + 1;
      doOpeningHourPeriod: DoOpeningHourPeriod = doOpeningHour.period;
    };
  }
  /**
   *
   * @param doOpeningHours
   */
  public static fromArray(doOpeningHours: any[]): DoOpeningHour[] {
    return doOpeningHours.map(_doOpeningHours => DoOpeningHourFactory.fromObject(_doOpeningHours));
  }
}
